var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"letter",on:{"mouseenter":_vm.enter,"mousemove":_vm.move,"mouseleave":_vm.leave}},[_vm._v(_vm._s(_vm.letter))])}
var staticRenderFns = []

export { render, staticRenderFns }